/* eslint-disable no-sequences */
import axios from "axios";
import { apiToken, apiUrl_forCart } from "./constants";

const CancelToken = axios.CancelToken;

// add cart
export let cancelAddCouponApi;
export async function addCoupon(token, coupon_code, temp_order_id, customer_id) {
    if (token, coupon_code, temp_order_id, customer_id) {
        const coupon = await axios.put(apiUrl_forCart + "apply/coupon",
            { coupon_code, temp_order_id, customer_id },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelAddCouponApi = c;
                }),
            }
        );
        return coupon;
    } else {
        console.log("Please add required parameters");
    }
}